import { useEffect, useState } from 'react';
// STEP #1: At the start of your file, import airwallex-payment-elements package
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/payment-page.css';
import CustomerDetails from './payment-page/customer-details';

const PaymentPage = () => {
  const [paymentDetails, setPaymentDetails] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  let isLoaded = false;

  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm();

  const fetchPaymentDetails = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/payment-page/${id}`
    );

    return result;
  };

  const onSuccess = async (data: any) => {
    console.log(data);
    navigate(`/payment-completed?orderId=${data.orderId}`, {
      replace: true,
    });
  };

  const onFailure = async (data: unknown, orderId: string) => {
    console.log(data);
    navigate(`/payment-failed?orderId=${orderId}`, { replace: true });
  };

  const onProcessing = async (data: unknown) => {
    console.log(data);
  };

  useEffect(() => {
    console.log(isLoaded);
    if (isLoaded) return;

    const getDetails = async () => {
      console.log('fetching payment details');
      // await instantiateAirWallex();
      const result = await fetchPaymentDetails();

      setPaymentDetails(result.data);
    };

    getDetails();

    return () => {
      isLoaded = true;
    };
  }, [id]);

  const onSubmit = async (data: unknown) => {
    console.log(data);
  };

  const formatCurrency = (amount: number, currency: string) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'usd',
      currencyDisplay: 'narrowSymbol',
    }).format(amount);
  };

  return (
    <div className="flex flex-row m-0 md:w-full h-max md:m-auto md:p-0 payment-page-body">
      {paymentDetails && (
        <>
          <div className="flex flex-col md:flex-row m-auto w-full p-4 float-right">
            <div className="md:w-1/2 mb-10 md:mb-0 md:ml-5 lg:ml-10 w-full">
              <div className="flex flex-col h-full right-0 md:float-right">
                <div className="flex flex-col md:w-96 float-right">
                  <div className="flex flex-row mb-4 float-right">
                    <img
                      src="https://badenbower.sgp1.digitaloceanspaces.com/bb-simple-logo.png"
                      className="w-9 rounded-full shadow-md"
                    />
                    <div className="text-gray-600 font-bold p-1 pl-0 ml-3">
                      Baden Bower
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="text-gray-600 font-semibold mb-1">
                      {paymentDetails.paymentPage?.name}
                    </div>
                    <div className="flex flex-row">
                      <div className="text-4xl font-semibold text-gray-700">
                        {paymentDetails &&
                          paymentDetails.paymentPage.recurring !==
                            'recurring' && (
                            <>
                              {paymentDetails.paymentPage.currency}
                              {formatCurrency(
                                paymentDetails.paymentPage.amount / 100,
                                paymentDetails.paymentPage.currency
                              )}
                            </>
                          )}
                        {paymentDetails.paymentPage.recurring ===
                          'recurring' && (
                          <>
                            {paymentDetails.paymentPage.currency}
                            {formatCurrency(
                              paymentDetails.paymentPage.amount / 100,
                              paymentDetails.paymentPage.currency
                            )}
                          </>
                        )}
                      </div>
                      <div className="text-xs ml-2 font-semibold text-gray-700 mt-1">
                        {paymentDetails.paymentPage.recurring ===
                          'recurring' && (
                          <>
                            Per <br />
                            Month
                          </>
                        )}
                        {paymentDetails.paymentPage.recurring !==
                          'recurring' && (
                          <>
                            Once <br />
                            off
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-gray-600 md:w-72">
                  {paymentDetails && (
                    <div>
                      {' '}
                      {paymentDetails.paymentPage?.description
                        ?.split('\n')
                        .map(function (item, idx) {
                          return (
                            <span key={idx}>
                              {item}
                              <br />
                            </span>
                          );
                        })}
                    </div>
                  )}
                  <img
                    src={paymentDetails.paymentPage?.image}
                    alt=""
                    className="w-full  md:w-72 rounded-md mt-4"
                  />
                </div>
              </div>
            </div>
            <div className="md:w-96 md:bg-none md:ml-5 lg:ml-10 w-full">
              <CustomerDetails
                paymentPageId={+id}
                onFailure={onFailure}
                onProcessing={onProcessing}
                onSuccess={onSuccess}
              ></CustomerDetails>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PaymentPage;
